import { createFileRoute, lazyRouteComponent } from "@tanstack/react-router";

export const Route = createFileRoute("/admin/agent-insights")({
  component: lazyRouteComponent(() => import("./-pages/admin.agent-insights")),
  head: () => ({ meta: [{ title: "Agent Insights | Lecmo Admin" }] }),
});
